import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackAddAdvClick } from './analytics';
import { AddOfferButton } from '../../components/AddOfferButton';
import { Section } from '../../components/Section';
import { selectAddFormLink } from '../../selectors/addFormLink';
import { useApplicationContext } from '../ApplicationContext';

export function AddOfferButtonContainer() {
  const { config } = useApplicationContext();
  const addFormLink = useSelector(selectAddFormLink);

  if (!config.get('mobileMainpage.addOfferButtonEnabled')) {
    return null;
  }

  return (
    <Section indent="M">
      <AddOfferButton addFormLink={addFormLink} onClick={trackAddAdvClick} />
    </Section>
  );
}
